module.exports = __webpack_public_path__ + "static/media/王小毅.44f1ec7e.png";